export enum ClickAction {
  OPEN_MAP = "openMap", //default
  SEND_TO_SRP = "sendToSRP",
  SEND_TO_HOTEL_INFOSITE = "sendToHotelInfoSite",
}
